import React, { useMemo } from "react";

export default function SchoolSwitcher() {
  const schools = useMemo(() => {
    try { return JSON.parse(localStorage.getItem("schools") || "[]"); }
    catch { return []; }
  }, []);
  const current = localStorage.getItem("school_id") || "";

  if (!Array.isArray(schools) || schools.length <= 1) return null;

  const onChange = (e) => {
    localStorage.setItem("school_id", e.target.value);
    window.location.reload(); // or trigger global refetch
  };

  return (
    <select value={current} onChange={onChange} style={{ padding: 6, borderRadius: 8 }}>
      {schools.map(s => (
        <option key={s.id} value={s.id}>
          {s.name} ({s.role})
        </option>
      ))}
    </select>
  );
}
